/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterSuspendOrg } from "../../funcs/authClusterSuspendOrg.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SuspendClusterOrgRequest$inboundSchema,
};

export const tool$authClusterSuspendOrg: ToolDefinition<typeof args> = {
  name: "auth-cluster-suspend-org",
  description: `Suspend an organization`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterSuspendOrg(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
